<template>
	<b-modal scrollable hide-header-close size="md" title="New Diagnostic Category" v-model="showModal" @ok="onOk" @hidden="onHidden" ok-title="Create" no-close-on-backdrop>

    <b-container>
  		<validation-observer ref="observer" v-slot="{ passes }">
  		<b-form novalidate>
        <validation-provider vid="tag" v-slot="{ errors }">
            <b-form-group
                label="Tag"
                :invalid-feedback="errors[0]"
                :state="errors[0] ? false : null">
                <b-form-input 
                    id="tag" 
                    v-model="form.tag" 
                    v-capitalize
                    placeholder="Enter tag (e.g., DM2, HT)" 
                    autocomplete="off">
                </b-form-input>
            </b-form-group>
        </validation-provider>

        <validation-provider vid="name" v-slot="{ errors }">
            <b-form-group
                label="Name"
                :invalid-feedback="errors[0]"
                :state="errors[0] ? false : null">
                <b-form-input 
                    id="name" 
                    v-model="form.name" 
                    v-capitalize
                    placeholder="Enter full name (e.g., Diabetes Mellitus Type 2)" 
                    autocomplete="off">
                </b-form-input>
            </b-form-group>
        </validation-provider>
		</b-form>
		</validation-observer>
  </b-container>
	</b-modal>
</template>

<script>
import ModalExtension from "@/core/components/modal/ModalExtension"
import { mapGetters, mapActions } from "vuex"
import moment from "moment"

export default ModalExtension.extend({
  data() {
    return {
      form: new Form({
          tag: "",
          name: "",
          consistency_token: null
      }),
    }
  },
  methods: {
    ...mapActions('patients', ['createDiagnosticCategory']),
    onOk(evt) {
      evt.preventDefault()
      this.createDiagnosticCategory(this.form.data())
        .then(() => {
          this.notify('Diagnostic category created', "Diagnostic category was created successfully")
          this.$emit('created')
          this.hide()
        })
        .catch(err => {
          if (err.response) {
            this.$refs.observer?.setErrors(err.response.data)
          }
        })
    }
  }
})
</script>
